import type { CandidateView } from "../../../api/content/curationApi";
import type { Review } from "../../../api/content/reviewDecoders";
import type { OutlineRow } from "../outline/reviewOutline";

/**
 * What the page offers to decide in bulk (curation-ui.md CU-9), pure. Module B serves each
 * unit's eligibility with the units, from the rule its bulk command refuses by, so the list
 * a curator confirms is the list that runs.
 */

/**
 * Units module B marks OK in bulk at this head (its `bulk_refusal`: no finding above `info`, no open possible
 * duplicate, no failing check), that I curate and have not marked OK.
 */
export function bulkMarkableRows(rows: readonly OutlineRow[], review: Review): readonly OutlineRow[] {
  const covered = new Set(review.summary.callerCurates.map((item) => item.itemId));
  return rows.filter((row) => row.unit.bulkRefusal === null && row.myMark !== "ok" && row.unit.items.some((item) => covered.has(item.itemId)));
}

/** Open proposals scored below the bulk threshold: probably no duplicates. */
export function bulkKeepableCandidates(candidates: readonly CandidateView[], threshold: number): readonly CandidateView[] {
  return candidates.filter((view) => view.candidate.state === "open" && view.candidate.scores.total < threshold);
}
